<app-summary-card
  [icon]="totalFeeCard().icon"
  [iconColor]="totalFeeCard().color"
  [cardTitle]="totalFeeCard().categoryTitle"
  [title]="totalFeeCard().categoryLabel"
  [formattedValue]="totalFeeCard().sumFees.grandTotalAllYears | appCurrency: totalFeeCard() : 0 : 0"
/>
